import React, { useEffect, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { whatsAppTemplate } from "../../utils/whatsAppUtils";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import MyTable from "../MyTable";
import { serviceUpdateClinicWhatsAppSetting } from "../../services/profileApi";
import { showToast } from "../../utils/toastUtils";

const WhatsAppSetingSection = ({
  collapsed,
  toggleSection,
  clinicDetail,
  msgCounter,
  //updateAddressInfo,
}) => {
  const [msgCounterR, setmsgCounter] = useState({});
  const [whatsAppTemplate1, setWhatsAppTemplate] = useState(whatsAppTemplate);
  const [whatsappData, SetWhatsappData] = useState([]);

  const handleCheckboxChange = (templateUniqueKey) => {
    setWhatsAppTemplate((prevState) => {
      return prevState.map((template) => {
        if (template.templateUniqueKey === templateUniqueKey) {
          return { ...template, checked: !template.checked };
        }
        return template;
      });
    });
  };

  const updatewhatsAppTemplateSetting = async (e) => {
    const token = localStorage.getItem("token");
    const decodedToken = jwtDecode(token);

    const response = await serviceUpdateClinicWhatsAppSetting({
      clinicId: decodedToken.clinic_ids[0],
      whatsapptemplate: whatsAppTemplate1,
    })
    
    if(response?.status){
      showToast(response?.message,"success")
    }else{
      showToast(response?.message,"error")
    }
  };

  useEffect(() => { 
    SetWhatsappData([
      {
        free_messages: msgCounterR.free_msg_count
          ? msgCounterR.free_msg_count
          : "0",
        total_sent_messages: msgCounterR.total_msg_count
          ? msgCounterR.total_msg_count
          : "0",
          remaining_message: msgCounterR.free_msg_count - msgCounterR.total_msg_count > 0 ? 
          msgCounterR.free_msg_count - msgCounterR.total_msg_count : "0",
          cost_per_msg:msgCounterR.cost_per_msg
          ? 'Rs. '+msgCounterR.cost_per_msg
          : "0",
            paid_amount:calculate_amount_paid(msgCounterR)
            ,
      },
    ]);

    if (msgCounter) {
      setmsgCounter(msgCounter);
    }

    if (Object.keys(clinicDetail?.whatsappTemplateSetting || {}).length > 0) {
      setWhatsAppTemplate(clinicDetail.whatsappTemplateSetting);
    }
  }, [clinicDetail?.whatsappTemplateSetting,msgCounterR]);

  const columns = [
    {
      Header: "Free messages for current month",
      accessor: "free_messages",
      id: "free_messages",
    },
    {
      Header: "Total Sent messages:",
      accessor: "total_sent_messages",
      id: "total_sent_messages",
    },
    {
      Header: "Remaining message",
      accessor: "remaining_message",
      id: "remaining_message",
    },
    {
      Header: "Cost per message",
      accessor: "cost_per_msg",
      id: "cost_per_msg",
    },
    {
      Header: "Amount to be paid",
      accessor: "paid_amount",
      id: "paid_amount",
    },
  ];

  const calculate_amount_paid =(msgCounterR)=>{
    if (msgCounterR.total_msg_count > msgCounterR.free_msg_count) {
      // Calculate the cost of extra messages
      const extraMsgCount = msgCounterR.total_msg_count - msgCounterR.free_msg_count;
      const extraMsgCost = extraMsgCount * msgCounterR.cost_per_msg;
      return 'Rs. '+extraMsgCost;
  } else {
      return 0;
  }
  }

  return (
    <div className="section">
      <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
        <div className="text-left"> WhatsApp setting</div>
        <button onClick={() => toggleSection("whatsAppInfo")}>
          {collapsed ? <FiPlus /> : <FiMinus />}
        </button>
      </div>
      {!collapsed && (
        <>
          <div className="section-content px-5 py-12 pt-4 ">
            <div className="  pb-2 text-gray-900 text-lg font-medium  pt-3 ">
              Send WhatsApp message on
            </div>
            <div className="flex flex-row flex-wrap gap-y-6">
              <div className="flex flex-wrap gap-2 justify-start">
                <div className="flex flex-wrap gap-2 justify-start">
                  {whatsAppTemplate1.map((template) => (
                    <React.Fragment key={template.templateUniqueKey}>
                      <label className="flex cursor-pointer items-center p-2 px-3 border border-gray-300 rounded-md">
                        <span className="relative inline-flex">
                          <input
                            type="checkbox"
                            checked={template.checked}
                            onChange={() =>
                              handleCheckboxChange(template.templateUniqueKey)
                            }
                            className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-blue-500 checked:bg-blue-500 checked:before:bg-blue-500 hover:before:opacity-10"
                          />
                          <div className="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-3.5 w-3.5"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="1"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </div>
                        </span>
                        <span className="ml-2 text-sm text-gray-700 capitalize">
                          {template.label}
                        </span>
                      </label>
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            <button
              className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5 bg-[#2E37A4] text-white mt-6"
              onClick={updatewhatsAppTemplateSetting}
            >
              Update
            </button>
          </div>

          <div className=" px-5">
            <div className="  pb-2 text-gray-900 text-lg font-medium  pt-5  border-t border-gray-200">
              Whatsapp stats for current month
            </div>

            <div className="  pb-12">
              <div className=" border">
                <MyTable
                  columns={columns}
                  data={whatsappData}
                  showPagination={false}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default WhatsAppSetingSection;
